import React, {Fragment} from "react";
import MultipleSelect from "../../../Shared/MultipleSelect";
import {useCurrentBriefList} from "../../../../queries/currentBrief";

const CurrentBriefSelect = ({id, disabled=false, values=[], onChange}) => {
    const {isLoading, data} = useCurrentBriefList();
    if(isLoading){
        return <Fragment />
    }

    const options = data.data.map(({id, name}) => {
        return {value: id, label: name};
    });

    return <MultipleSelect
        id={id}
        disabled={disabled}
        options={options}
        values={values}
        onChange={onChange}
    />
};

export default CurrentBriefSelect;
